
import { Mail } from "lucide-react";
import { Badge } from "@/components/ui/badge";

type PendingInvitation = {
  id: string;
  email: string;
  status: string;
  organization_id: string;
};

type PendingInvitationsListProps = {
  pendingInvites: PendingInvitation[];
};

const PendingInvitationsList = ({ pendingInvites }: PendingInvitationsListProps) => {
  if (pendingInvites.length === 0) {
    return null;
  }

  return (
    <div className="mt-8 border-t border-gray-200 pt-6">
      <h3 className="text-md font-medium mb-4">Invitations en attente</h3>
      <div className="space-y-2">
        {pendingInvites.map((invite) => (
          <div key={invite.id} className="flex items-center justify-between p-3 bg-gray-50 rounded-md">
            <div className="flex items-center">
              <Mail className="h-4 w-4 text-gray-500 mr-2" />
              <span className="text-sm text-gray-700">{invite.email}</span>
            </div>
            <Badge className="bg-amber-100 text-amber-700">En attente</Badge>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PendingInvitationsList;
